document.addEventListener('DOMContentLoaded', () => {
  const tippyItems = document.querySelectorAll('[data-tippy="bra-calculator"]');

  if (tippyItems.length === 0) return;

  tippyItems.forEach(item => {
    tippy(item, {
      content: item.dataset.tippyContent,
      allowHTML: true,
      duration: 150,
      trigger: 'mouseenter click',
      theme: 'bra-calculator',
      animation: 'shift-away'
    });
  });
});
